<div class="side-event-details w-full h-full p-6">
  <div class="flex mb-4 text-gray-600">
    <mat-icon (click)="back.emit()" matTooltip="close" class="cursor-pointer">chevron_right</mat-icon>
  </div>

  <ig-image [src]="event.cover?.source" cls="w-full rounded-2xl"></ig-image>

  <div class="text-2xl font-bold text-gray-700 my-6" [class.mb-3]="event.isChoice">{{ event.name }}</div>

  <div *ngIf="!frontendSettings?.customSettings?.isHideEditorChoice && event.isChoice"
       class="w-1/2 py-2 mb-3 bg-gradient-to-b from-[#b04aea] to-[#773bf2] text-xs text-white text-center">
    <span class="text-xs">{{ frontendSettings?.customSettings.customEditorChoice.editorChoiceForEvent }}</span>
  </div>

  <div *ngIf="event.eventTimes.length<=1" class="{{event.categories?.length?'mb-4':'mb-6'}}">
    <div class="text-base text-gray-600">{{ event.timeTwoLines?.date }}</div>
    <div class="text-base text-gray-600">{{ event.timeTwoLines?.time }}</div>
  </div>
  <div *ngIf="event.eventTimes.length>1" class="{{event.categories?.length?'mb-4':'mb-6'}}">
    <ig-multi-event-times [event]="event"></ig-multi-event-times>
  </div>

  <div *ngIf="event.categories?.length" class="flex gap-2 mb-6">
    <a *ngFor="let category of event.categories" [href]="category.link" target="_blank"
       class="py-1 px-2 bg-[#E4E6EB] text-xs text-gray-700 rounded-[4px] h-7 leading-5">
      {{ category.name }}
    </a>
  </div>

  <ng-container *ngIf="event.multiHosts?.length">
    <div class="text-lg text-gray-700 font-bold mb-3 mt-2">Meet the Host{{ event.multiHosts.length > 1 ? 's' : '' }}
    </div>
    <div *ngFor="let host of event.multiHosts" class="flex items-center gap-4 mt-3">
      <ig-image cls="w-[60px] h-[60px] rounded-full mobile:w-[60px] mobile:h-[60px] outline outline-[#41abf3]"
                [src]="host.img"></ig-image>
      <div>
        <a class="text-sm font-bold" [href]="host.link" target="_blank">{{ host.name }}</a>
        <div class="text-xs text-gray-600">{{ host.about }}</div>
      </div>
    </div>
  </ng-container>

  <div class="text-lg text-gray-700 font-bold mb-3 mt-6">Description</div>
  <div #description class="my-4 text-gray-600 max-h-48 overflow-hidden sun-editor-editable"
       [class.!max-h-fit]="isShowingMore"
       [innerHtml]="(event.description || '(No Description)') | secureHtml">
  </div>
  <!--  if you use bypassSecurityTrustHtml directly in html it will not allow to copy the text-->
  <!--  <div #description class="my-4 text-gray-600 max-h-48 overflow-hidden sun-editor-editable"-->
  <!--    [class.!max-h-fit]="isShowingMore"-->
  <!--    [innerHTML]="sanitizer.bypassSecurityTrustHtml(event.description || '(No Description)')">-->
  <!--  </div>-->
  <div *ngIf="isNeedScroll()||isShowingMore" class="mt-4 cursor-pointer text-center text-[#3476d2]"
       (click)="isShowingMore=!isShowingMore">show {{ isShowingMore ? 'less' : 'more' }}
  </div>

  <ig-info-ticket [event]="event" class="block mt-6"></ig-info-ticket>

  <div class="mt-2 pb-12">
    <div class="text-lg text-gray-700 font-bold mb-3">Address</div>
    <div *ngIf="!event.isOnlineEvent">
      <div *ngIf="event?.hostLink&&eventService.venueName(event)" class="text-sm font-semibold text-gray-600">
        {{ eventService.venueName(event) }}
      </div>
      <div *ngIf="event?.venueInfo?.rating">
        <span class="mr-3 text-sm text-gray-500">
          Rating: {{ event.venueInfo.rating }}</span>
        <ig-stars class="relative top-[2px] mr-3" [rating]="event.venueInfo?.rating"></ig-stars>
        <span *ngIf="event?.venueInfo?.reviews" class="text-sm text-gray-600">{{ event.venueInfo?.reviews }}
          reviews</span>
      </div>
    </div>
    <div class="text-sm text-gray-600">{{ event.address?.address }}</div>
  </div>
</div>
